import { render } from "./WelcomeBack.vue?vue&type=template&id=c7b1e2a8&scoped=true"
import script from "./WelcomeBack.vue?vue&type=script&lang=js"
export * from "./WelcomeBack.vue?vue&type=script&lang=js"

import "./WelcomeBack.vue?vue&type=style&index=0&id=c7b1e2a8&scoped=true&lang=css"

import exportComponent from "/var/www/html/online-ordering/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c7b1e2a8"]])

export default __exports__